import { render, staticRenderFns } from "./ModalEditDistribution.vue?vue&type=template&id=68b5d37e&"
import script from "./ModalEditDistribution.vue?vue&type=script&lang=ts&"
export * from "./ModalEditDistribution.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports